import React from 'react';
import { ClockIcon, RefreshCwIcon } from '@newcore/icons';
import { Button } from '@newcore/ui/buttons';
import { Sizes } from '@newcore/ui/enums/sizes';

interface PairingExpiredStateProps {
  onRetry: () => void;
}

/**
 * Expired state - shown when pairing code expires
 */
export const PairingExpiredState: React.FC<PairingExpiredStateProps> =
  React.memo(({ onRetry }) => (
    <div
      data-testid='pairing-expired-state'
      className='flex flex-col items-center py-8 space-y-4'
    >
      <div className='rounded-full bg-secondary p-3'>
        <ClockIcon className='h-12 w-12 text-tertiary' />
      </div>
      <p className='text-center text-tertiary'>The pairing code has expired</p>
      <Button
        onClick={onRetry}
        size={Sizes.LG}
        iconLeading={RefreshCwIcon}
        data-testid='pairing-expired-retry-button'
      >
        Generate New Code
      </Button>
    </div>
  ));

PairingExpiredState.displayName = 'PairingExpiredState';
